<div class="outer-container">
  <div class="horizontal-border top-border"></div>
  <div class="vdev-container">
    <div class="vertical-border left-border"></div>
    <div class="content-container">
      <ng-content></ng-content>
    </div>
    <div class="vertical-border right-border"></div>
  </div>
  <div class="bottom-border-container">
    <div class="horizontal-border bottom-border"></div>
    <div class="enclosure-container">
      <ix-icon name="ix:enclosure"></ix-icon>
      <strong>{{ enclosure }}</strong>
    </div>
    <div class="horizontal-border bottom-border"></div>
  </div>
</div>